import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {
    filterDropdown_template
} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template";
import {filterArticle_template} from "./filterArticle_template";
import {PollMarkup} from "./pollMarkup";

declare var ko: any;

export class pollsView_template extends vnTemplate {


    public brandSingleFilter: filterDropdown_template;
    protected referenceArticle: filterArticle_template;

    protected getTemplateHtml(): string{
        return `
            <div class="w-form w-form-large form-poll">
                <div class="form-header">
                    <input id="poll-id" data-bind="value: id" type="hidden">
                    <button class="btn icon i-back" type="button" data-bind="event: { click: onClickCancel }">Go Back</button> 
                    <h3 class="form-title icon i-poll">Poll</h3>
                    <button class="btn icon i-edit" type="button" data-bind="event: { click: onClickEdit }">Edit Poll</button>                    
                </div>

                ${ PollMarkup.sectionHeading('Info') }
                ${ PollMarkup.viewInfoPanel() }
                ${ PollMarkup.sectionHeading('Questions') }
                ${ PollMarkup.viewToolbar(this.brandSingleFilter.getHtmlBuild()) }
                ${ PollMarkup.emptyQuestions() }
                ${ PollMarkup.questionViewCards() }
            </div>
        `;
    }

    protected initPartial(): void {

        this.brandSingleFilter = new filterDropdown_template("brandSingleFilter", this.getTemplateViewModel(), this.caller);
        this.referenceArticle = new filterArticle_template('referenceArticle', this.getTemplateViewModel(), this.caller);
        this.referenceArticle.setShowDetails(true);

    }

    protected getTemplateName(): string{
        return "pollsView-template";
    }

    protected getMainElementType(): string{
        return "div";
    }

    protected buildViewModel(): any{

        let self = this;
        return  {
            id: ko.observable(null),
            brandId: ko.observable(null),
            name: ko.observable(""),
            description: ko.observable(""),
            attachedBrands: ko.observable(""),
            type: ko.observable(""),
            discussionArticleTitle: ko.observable(""),
            referenceArticleTitle: ko.observable(""),
            idReferenceArticle: ko.observable(null),
            idReferenceBrand: ko.observable(null),
            dateClosed: ko.observable(),
            dateCreated: ko.observable(),
            questions: ko.observableArray([]),
            exportInProgress: ko.observable(false),
            exportTextBox: ko.observable("Export to CSV"),
            brandReferences: ko.observableArray([]),
            onClickCancel: (data, event) => { self.onClickCancel(data) },
            onClickEdit: (data, event) => { self.onClickEdit(data) },
            onClickGenerateBasedOnArticle: () => { self.caller.generateBasedOnArticle(); },
            onClickExportToCSV: (data) => { self.onClickExportToCSV(data)}
        };
    }

    public getSelectionBrandId() {
        let selectedBrand =  this.brandSingleFilter.getSelectedOption();
        if (selectedBrand && selectedBrand.id > 0) {
            return selectedBrand.id;
        }

        return null;
    }

    public onClickEdit(data){

        let brandId = this.getBrandId();
        let pollId = this.getId();
        this.caller.edit(pollId, brandId);

    }

    public onClickExportToCSV(data) {
        console.log('onClickExportToCSV', data);
        this.asExportInProgress(true);
        this.setExportTextBox("Exporting...");

        this.caller.exportPoll();
    }

    public onClickCancel(data){
        let brandId = this.getBrandId();
        let pollId = this.getId();

        this.caller.cancel(pollId, brandId);
    }

    public setId(id){
        this.getTemplateViewModel().id(id);
    }

    public getId() {
        return this.getTemplateViewModel().id();
    }

    public setBrandId(brandId) {
        this.getTemplateViewModel().brandId(brandId);
    }

    public getBrandId() {
        return this.getTemplateViewModel().brandId();
    }

    public setName(name){
        this.getTemplateViewModel().name(name);
    }
    public getName(){
        return this.getTemplateViewModel().name();
    }

    public setDescription(description){
        this.getTemplateViewModel().description(description);
    }

    public getDescription(){
        return this.getTemplateViewModel().description();
    }

    /** Discussion article of the brand in context; the other brands' articles are not this screen's business. */
    public setDiscussionArticleTitle(discussionArticleTitle){
        this.getTemplateViewModel().discussionArticleTitle(discussionArticleTitle || "");
    }

    public setArticleOptions(articles) { this.referenceArticle.setOptions(articles); }
    public setReferenceArticle(article) {
        const articleId = article && (article.id || article.idArticle);
        const articleTitle = article ? (article.title || article.name || `Article #${articleId}`) : '';
        this.referenceArticle.setSelectedArticle(article ? {
            ...article,
            id: articleId,
            title: articleTitle,
        } : null);
        this.getTemplateViewModel().referenceArticleTitle(articleTitle);
        this.getTemplateViewModel().idReferenceArticle(articleId || null);
        this.referenceArticle.setDisableField(!!this.getTemplateViewModel().idReferenceArticle());
    }
    public getReferenceArticleId() { return this.getTemplateViewModel().idReferenceArticle() || this.referenceArticle.getTemplateViewModel().idArticle(); }
    public getReferenceBrandId() { return this.getTemplateViewModel().idReferenceBrand() || this.getBrandId(); }
    public setReferenceBrandId(idReferenceBrand) { this.getTemplateViewModel().idReferenceBrand(idReferenceBrand || this.getBrandId()); }

    public setType(type){
        this.getTemplateViewModel().type(type);
    }

    public setBrandReferences(brandReferences) {

        let lightReferences = [];
        for (const br of brandReferences) {
            lightReferences.push({id: br.id, name: br.name, shortName: br.shortName});
        }

        this.getTemplateViewModel().brandReferences(lightReferences)
    }

    public getCurrentBrandName() {
        let selectedBrand = this.brandSingleFilter.getSelectedOption();
        if (selectedBrand) {
            // @ts-ignore
            return selectedBrand.shortName;
        }

        return null;
    }

    public getBrandReferences() {
        return this.getTemplateViewModel().brandReferences()
    }

    public setDateClosed(dateClosed){
        this.getTemplateViewModel().dateClosed(dateClosed);
    }

    public setDateCreated(dateCreated) {
        this.getTemplateViewModel().dateCreated(dateCreated);
    }

    public setQuestions(questions){
        this.getTemplateViewModel().questions(questions);
    }

    public getQuestions(): any[] {
        return this.getTemplateViewModel().questions();
    }

    public asExportInProgress(exportInProgress) {
        this.getTemplateViewModel().exportInProgress(exportInProgress);
    }

    public isExportInProgress() {
        return this.getTemplateViewModel().exportInProgress();
    }

    public setExportTextBox(exportTextBox) {
        this.getTemplateViewModel().exportTextBox(exportTextBox);
    }

    public getExportTextBox() {
        return this.getTemplateViewModel().exportTextBox();
    }

    public setBrandResults(networkResults, brandResults) {

        networkResults = Array.isArray(networkResults) ? networkResults : [];
        brandResults = Array.isArray(brandResults) ? brandResults : [];
        this.setQuestions(networkResults);

        let references = this.getBrandReferences() || [];

        let brandRerences = [];
        brandRerences.push({id: -1, name: 'Network', questions: networkResults, shortName: 'Network' });
        let brandNames = [];
        for (let ref of references) {
            for (let r of brandResults) {
                if (r.isActive && r.idBrand === ref.id) {
                    brandRerences.push({id: ref.id, name: ref.name, questions: r.questions, shortName: ref.shortName});
                    brandNames.push(ref.shortName);
                }
            }
        }

        this.setAttachedBrands(brandNames.join(', '));
        this.brandSingleFilter.setOptions(brandRerences);
        this.brandSingleFilter.setSelectedOption(-1);
    }

    public handleBrandChange(idElement) {

        let selectedBrand = this.brandSingleFilter.getSelectedOption();

        if (selectedBrand) {
            this.setQuestions([]);
            // @ts-ignore
            this.setQuestions(selectedBrand.questions);
        }
    }

    public setAttachedBrands(attachedBrands) {
        this.getTemplateViewModel().attachedBrands(attachedBrands);
    }

    public getAttachedBrands() {
        return this.getTemplateViewModel().attachedBrands();
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/pollsView_template.ts